export default __webpack_public_path__ + "static/media/base-footer-banner-right.55ee4221.png";